import { Select } from '@fabric-ds/react';
import { Filters } from '@/domain';

type SortingProps = {
    filters: Filters;
    onFilterChanged: (filters: Filters) => void;
};

export const Sorting = ({ filters, onFilterChanged }: SortingProps) => (
    <div className="text-right">
        <label className="inline-block mr-8" htmlFor="sort">
            Sortér på
        </label>
        <Select
            className="inline-block mb-8"
            data-testid="ResultPage-sorting"
            id="sort"
            value={filters.sorting ? filters.sorting : 'best'}
            onChange={(event) => onFilterChanged({ sorting: event.target.value })}>
            <option value="best">Beste treff</option>
            <option value="published">Publisert</option>
            <option value="price_asc">Pris lav-høy</option>
            <option value="price_desc">Pris høy-lav</option>
            <option value="bedroom_asc">Soverom lav-høy</option>
            <option value="bedroom_desc">Soverom høy-lav</option>
        </Select>
    </div>
);
